module.exports = __webpack_public_path__ + "static/media/pay-online.39038179.svg";